__turbopack_context__.v({
  "contactCardColumnContainer": "E1BdHW_contactCardColumnContainer",
  "exposeContentWrapper": "E1BdHW_exposeContentWrapper",
  "pageContainer": "E1BdHW_pageContainer",
});
